import { Host } from '@wix/sdk';
import { CssPropertyType } from '../../types';
import { SpacingControlPanelData } from '../types';
import { useSpacingClients } from './useSpacingClients';
import { useSpacingData } from './useSpacingData';
import { useSpacingControl } from './useSpacingControl';

export const useSpacingPanel = (
  hosts: Host[],
  allowedStyles: CssPropertyType[],
): SpacingControlPanelData => {
  const clients = useSpacingClients(hosts);
  const data = useSpacingData(clients, allowedStyles);
  const control = useSpacingControl(data);

  return {
    sharedValue: control.sharedValue,
    percentageValue: control.percentageValue,
    isMixed: control.isMixed,
    isControlVisible: control.isControlVisible,
    onChange: control.onChange,
  };
};
